const StatusTag = ({ status }) => {
    return (
        <span className="bg-indigo-100 text-indigo-800 text-sm font-medium px-2.5 py-0.5 rounded">
            {status}
        </span>
    );
};

export default StatusTag;